export var DEFAULT_COUNTRY = 'USA';
export var PAYMENT_SOURCE_KEY = 'paymentSource';
export var CUSTOMER_KEY = 'customer';
export var FULFILLMENT_KEY = 'fulfillment';
export var TIP_KEY = 'tip';
export var SPECIAL_INSTRUCTIONS_KEY = 'specialInstructions';
export var DEFAULT_FULFILLMENT_DATA = {
  firstName: '',
  lastName: '',
  country: DEFAULT_COUNTRY,
  state: '',
  city: '',
  postalCode: '',
  line1: '',
  line2: '',
  isVerified: false
};